import { render, staticRenderFns } from "./NewChatEmojiPicker.vue?vue&type=template&id=a5cec9a0"
import script from "./NewChatEmojiPicker.vue?vue&type=script&lang=js"
export * from "./NewChatEmojiPicker.vue?vue&type=script&lang=js"
import style0 from "./NewChatEmojiPicker.vue?vue&type=style&index=0&id=a5cec9a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports